import * as z from "zod"

// Helper schema for JSON fields
type Literal = boolean | number | string
type Json = Literal | { [key: string]: Json } | Json[]
const literalSchema = z.union([z.string(), z.number(), z.boolean()])
const jsonSchema: z.ZodSchema<Json> = z.lazy(() => z.union([literalSchema, z.array(jsonSchema), z.record(z.string(), jsonSchema)]))

export const DataDeletionRequestDbModel = z.object({
  /**
   * Also the correlation key in `deletion_log` and in Rotor's logs. Generated here, never
   * accepted from the caller: the column is a global primary key, so a caller-supplied value
   * could collide with another workspace's row and reveal that it exists.
   */
  id: z.string(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  workspaceId: z.string(),
  /**
   * The subject. At least one of these is always set; which one a vendor can act on varies.
   * This is the only place the subject's identifiers are stored — `deletion_log` deliberately
   * holds none, so that the audit trail for erasing someone does not itself need erasing.
   */
  email: z.string().nullish(),
  userId: z.string().nullish(),
  /**
   * Free text from the intake form, for an operator matching a request back to a support thread.
   */
  customerName: z.string().nullish(),
  /**
   * Who filed it, as a plain email string rather than a relation. Requests arrive through Hub,
   * whose users do not exist in Console's user table, so there is no row to point at.
   */
  submittedByEmail: z.string().nullish(),
  /**
   * When Console handed the request to Rotor. Null means the dispatch never succeeded, which is
   * the one failure this row records directly; everything after dispatch lives in ClickHouse.
   */
  forwardedAt: z.coerce.date().optional().nullish(),
  /**
   * The dispatch manifest: every connection Rotor accepted the request for, captured at dispatch
   * time. Denormalized on purpose — connections are deleted and recreated with new ids, so
   * resolving these against current config later is guaranteed to break, and this is the only
   * record of what the fan-out was supposed to reach.
   */
  manifest: jsonSchema,
})
